import { defaultSettings } from "css/defaultAntStyles";

export const CommentTooltip = (props) => {
  if (!props.value) return null;
  return (
    <div
      style={{
        background: "#1f1f1f",
        color: "#fff",
        border: `1px solid ${defaultSettings.colorPrimary}`,
        borderRadius: 8,
        padding: 10,
        maxWidth: 320,
        whiteSpace: "normal",
        wordBreak: "break-word",
        lineHeight: 1.4,
        boxShadow: "0 4px 12px rgba(0,0,0,0.35)",
      }}
    >
      <div>{props.value}</div>
    </div>
  );
};
